import { merge } from 'lodash-es';

export interface ActivityModel {
  id: string;
  activity: string;
  details: any[];
  [key: string]: any;
}

// Types
export interface Sorter {
  property: string;
  direction: string
}

export interface Filters {
  ['contained_text']: string
}

export interface ActivitiesOptions {
  filters: Filters;
  sorters: Sorter[];
  page: number;
  start: number;
  limit: number;
}

export interface ActivitiesState {
  activities: ActivityModel[],
  filters: string[]
}

const fetchActivitiesDefaultOptions: ActivitiesOptions = {
  filters: {
    contained_text: ''
  },
  sorters: [
    {
      property: 'timestamp',
      direction: 'DESC'
    }
  ],
  page: 1,
  start: 0,
  limit: 256
};

const activitiesState: ActivitiesState = {
  activities: [],
  filters: []
};

const activitiesGetters: CommonGetterTree<ActivitiesState> = {
  getItemById: state => id => state.activities.find(activity => activity.id === id)
};

const activitiesMutations: CommonMutationTree<ActivitiesState> = {
  FETCH_ACTIVITIES_SUCCESS(state, payload: any): void {
    state.activities = payload.map((item) => ({ ...item, id: String(item.id) }));
  },
  FETCH_ACTIVITIES_ERROR(state): void {
    state.activities = [];
  },
  SET_ACTIVITIES_FILTERS(state, payload: any): void {
    state.filters = [...payload].sort((a, b) => a.localeCompare(b));
  },
  CLEAR_LIST(state): void {
    state.activities = [];
  }
};

const activitiesActions: CommonActionTree<ActivitiesState> = {
  FETCH_ACTIVITIES({ commit }, payload: any = {}): Promise<FetchResponse> {
    const { options, ...params } = payload;
    commit('LOADING');
    return this.$api.get('/api/v2/audit_log', {
      params: merge({}, fetchActivitiesDefaultOptions, params)
    }, options)
      .then((response: FetchResponse) => {
        if (response?.data?.data
          && Array.isArray(response.data.data)) {
          commit('FETCH_ACTIVITIES_SUCCESS', response?.data?.data);
        } else {
          commit('FETCH_ACTIVITIES_ERROR');
        }
        return response;
      })
      .catch((error) => {
        commit('FETCH_ACTIVITIES_ERROR', error?.data);
        throw error;
      })
      .finally(() => {
        commit('LOADED');
      });
  },
  FETCH_ACTIVITIES_FILTERS({ commit }, payload: any = {}): Promise<FetchResponse> {
    const { options, ...params } = payload;
    return this.$api.get('/api/v2/audit_log/activities/', params, options)
      .then((res) => {
        commit('SET_ACTIVITIES_FILTERS', res.data);
        return res;
      });
  }
};

export default new class implements CommonStore<ActivitiesState, unknown> {
  name = 'activities';
  resource = '/api/v2/audit_log';
  actions = activitiesActions;
  getters = activitiesGetters;
  mutations = activitiesMutations;
  state = activitiesState;
}();
